<template>
  <div class="warninglogin">
  <a-layout id="components-layout-demo-top" class="layout">
    <headerComponent :showNormal="true"></headerComponent>
    <a-layout-content>
      <a-breadcrumb class="bgCrumb">
        <a-breadcrumb-item>方案列表</a-breadcrumb-item>
        <!-- <a-breadcrumb-item>List</a-breadcrumb-item>
        <a-breadcrumb-item>App</a-breadcrumb-item> -->
      </a-breadcrumb>
      <div class="dataContent">
         <a-form  :model="formData" layout="inline" class="form-class">
          <div class="row1"> 
              <a-input v-model:value="formData.name" @pressEnter="search" placeholder="请输入方案名称" style="width: 260px">
                 <template #suffix>
                  <SearchOutlined  @click="search" />
                 </template>
              </a-input>
               <!-- <a-button
                type="primary"
                @click="search"
                class="dban"
                style="margin-left: 20px"
              >
                 搜索
              </a-button> -->
              <a-button
                @click="add"
                type="primary"
                class="dban"
                style="margin-left: 20px"
              >
                + 新建
              </a-button>
              <a-popconfirm
                placement="bottom"
                ok-text="确定"
                cancel-text="重置"
                @confirm="confirm"
                @cancel="reset"
              >
               <template #icon>
               <a-icon/>
               </template>
              <template #title>
                  <a-checkbox v-model:checked="isChecked1" value="1" name="type">创建时间</a-checkbox>
                  <a-checkbox v-model:checked="isChecked2" value="2" name="type">修改时间</a-checkbox>
              </template>
                <SettingOutlined style="padding:10px;font-size:18px"/>
              </a-popconfirm>
              <!-- <a-icon type="setting" @click="showModel" /> -->
          </div>
       <a-table
          bordered
          :row-key="(record) => record.id"
          :dataSource="dataSource"
          :columns="columns"
          :pagination="false"
        >
          <template #setIndex="{ index }">
           {{index+1}}
          </template>
          <template #operation="{ record }">
            <a  @click="showModal(record.id)">编辑</a>
           &nbsp; &nbsp;
            <a v-if="record.status==0"  @click="down(record.id,'1')">暂停</a>
            <a class="disabled" v-else @click="down(record.id,'0')">启用</a>
            &nbsp; &nbsp;
            <a-popconfirm
              v-if="dataSource.length"
              title="确认删除组合?"
              @confirm="onDelete(record.id)"
              cancelText="取消"
              okText="确认"
            >
              <a>删除</a>
            </a-popconfirm>
          </template>
        </a-table>
        <a-pagination show-size-changer show-quick-jumper
        v-model:current="current"
        v-model:page-size-options="pageSizeOptions"
        v-model:pageSize="pageSize"
        @change="changeData"  @showSizeChange="onShowSizeChange" :total="total" />
      </a-form>
      </div>
    </a-layout-content>
    <a-layout-footer style="text-align: center">
      <!-- Copy Right ©2021 -->
    </a-layout-footer>
  </a-layout>
<!-- <style>

</style> -->

    <!-- <div>
      <a-page-header
        style="border: 1px solid rgb(235, 237, 240)"
        title="预警列表"
      />
      <a-card style="line-height: 2">
        <a-row style="margin: auto 240px">
          <a-col>
            <a-col><a-span style="font-size: 26px">预警列表</a-span></a-col>
          </a-col>
        </a-row>
      </a-card>
    </div> -->
    <!-- <a-layout-footer></a-layout-footer> -->
     <div class="hoverBottomWapper"> 
      <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
      </div>
    </div>
  </div>
</template>
<script>
import { message,Modal } from 'ant-design-vue';
import { SettingOutlined ,SearchOutlined } from '@ant-design/icons-vue';
import { getList,deleteyj,changeStatus } from "../../utils/api";
// import headerComponent from './header';
import headerComponent from '../../components/header'
import '../../lib/rem.js'
// import { SmileOutlined, DownOutlined } from '@ant-design/icons-vue';
// import { defineComponent, watch } from 'vue';
// const ,
//   ]
let localDataSource = [];
export default {
data() {
    return {
      formState:{
        type:''
      },
      // showBtn:false,
      isChecked1:false,
      isChecked2:false,
      isChecked3:true,
      isChecked4:true,
        pageSizeOptions: ['10', '20', '50', '100'],
        columns1:[
    {
      title: "No.",
      dataIndex: "setIndex",
      key: "setIndex",
      isCheck:true,
      slots: {
        customRender: "setIndex",
      },
    },
    {
      title: "预警名称",
      dataIndex: "name",
      sorter:(a,b) => a.name.localeCompare(b.name),
      key: "name",
      isCheck:true,
    },
    {
      title: "所选关键词数量",
      dataIndex: "keywordCount",
      align:"right",
      sorter:(a,b) => Number(a.keywordCount) - Number(b.keywordCount),
      key: "keywordCount",
      isCheck:true
    },
    {
      title: "所选平台数",
      align:"right",
      dataIndex: "netCount",
      sorter: (a, b) => Number(a.netCount) - Number(b.netCount),
      key: "netCount",
      isCheck:true
    },
    {
      title: "收件人数",
       align:"right",
       sorter: (a, b) => Number(a.emailCount) - Number(b.emailCount),
      dataIndex: "emailCount",
      key: "emailCount",
      isCheck:true
    },
    {
      title: "操作",
      align:"right",
      dataIndex: "operation",
      slots: {
        customRender: "operation",
      },
    },
  ],
      columns:[
    {
      title: "No.",
      dataIndex: "setIndex",
      key: "setIndex",
      isCheck:true,
      slots: {
        customRender: "setIndex",
      },
    },
    {
      title: "预警名称",
      dataIndex: "name",
      sorter:(a,b) => a.name.localeCompare(b.name),
      key: "name",
      isCheck:true,
    },
    {
      title: "所选关键词数量",
      dataIndex: "keywordCount",
      align:"right",
      sorter:(a,b) => Number(a.keywordCount) - Number(b.keywordCount),
      key: "keywordCount",
      isCheck:true
    },
    {
      title: "所选平台数",
      align:"right",
      dataIndex: "netCount",
      sorter: (a, b) => Number(a.netCount) - Number(b.netCount),
      key: "netCount",
      isCheck:true
    },
    {
      title: "收件人数",
       align:"right",
       sorter: (a, b) => Number(a.emailCount) - Number(b.emailCount),
      dataIndex: "emailCount",
      key: "emailCount",
      isCheck:true
    },
    {
      title: "操作",
      align:"right",
      dataIndex: "operation",
      slots: {
        customRender: "operation",
      },
    },
  ],
  old1Colmns:[],
  oldColumns:[
     {
      title: "No.",
      dataIndex: "setIndex",
      key: "setIndex",
      isCheck:true,
      slots: {
        customRender: "setIndex",
      },
    },
    {
      title: "预警名称",
      dataIndex: "name",
      sorter:(a,b) => a.name.localeCompare(b.name),
      key: "name",
      isCheck:true,
    },
    {
      title: "所选关键词数量",
      dataIndex: "keywordCount",
      align:"right",
      sorter:(a,b) => Number(a.keywordCount) - Number(b.keywordCount),
      key: "keywordCount",
      isCheck:true
    },
    {
      title: "所选平台数",
      align:"right",
      dataIndex: "netCount",
      sorter: (a, b) => Number(a.netCount) - Number(b.netCount),
      key: "netCount",
      isCheck:true
    },
    {
      title: "收件人数",
       align:"right",
       sorter: (a, b) => Number(a.emailCount) - Number(b.emailCount),
      dataIndex: "emailCount",
      key: "emailCount",
      isCheck:true
    },
     {
      title: "创建时间",
      dataIndex: "createTime",
        align:"right",
      key: "createTime",
      sorter: (a, b) => a.createTime.localeCompare(b.createTime),
      isCheck:false
    },
      {
      title: "修改时间",
        align:"right",
      dataIndex: "updateTime",
      key: "updateTime",
      sorter: (a, b) => a.updateTime.localeCompare(b.updateTime),
      isCheck:false
    },
    {
      title: "操作数",
      isCheck:true,
      dataIndex: "operation",
      slots: {
        customRender: "operation",
      },
    },
  ],
  current:1,
      dataSource:[],
      pageNo:1,
      pageSize:10,
      total:0,
      formData:{
        name:""
      }
    }
},
components:{
    SettingOutlined,
    headerComponent,
    SearchOutlined
},
methods:{
  reset(){
    this.columns = this.columns1;
    this.isChecked1 = false;
    this.isChecked2 = false;
  },
  confirm(){
  this.old1Colmns = []
   if(!this.isChecked1){
     this.oldColumns[5].isCheck = false;
   }else{
     this.oldColumns[5].isCheck = true;
   }
  if(!this.isChecked2){
     this.oldColumns[6].isCheck = false;
   }else{
     this.oldColumns[6].isCheck = true;
   }
  // if(!this.isChecked3){
  //    this.oldColumns[3].isCheck = false;
  //  }else{
  //    this.oldColumns[3].isCheck = true;
  //  }
  // if(!this.isChecked4){
  //    this.oldColumns[2].isCheck = false;
  //  }else{
  //    this.oldColumns[2].isCheck = true;
  //  }
  //  console.log(this.columns)
   let that = this;
   that.oldColumns.map((cur,index)=>{
        if(cur.isCheck){
          that.old1Colmns.push(that.oldColumns[index])
        }
   })
   that.columns = that.old1Colmns
  },
  search(){
    this.getData()
  },
  down(id,val){
    let that = this;
    if(val=='0'){
       Modal.confirm({
        title: '确定启用组合么?',
        onOk() {
          changeStatus({id:id,status:val}).then(res=>{
            message.success('启用成功')
            that.getData()
          })
        },
        onCancel() {
        },
      });
     
    }else{
      Modal.confirm({
        title: '确定暂停组合么?',
        onOk() {
          changeStatus({id:id,status:val}).then(res=>{
            message.success('暂停成功')
            that.getData()
          })
        },
        onCancel() {
        },
      });
    }
  
  },
  onDelete(id){
    deleteyj(id).then(res =>{
      message.info('删除成功');
      this.getData()
    })
  },
  add(){
    if(this.total>20){
      message.info('每个账号最多可建20个预警方案')
      return
    }
    this.$router.push({ path: "/warningAdd" });
  },
  changeData(pageNo,pageSize){
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.getData();
  },
  onShowSizeChange(pageNo,pageSize){
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.getData();
  },
  showModal(id){
    this.$router.push({path:"/warningEdit",query:{id}});
  },
  getData(){
    getList({pageNo:this.pageNo,pageSize:this.pageSize,title:this.formData.name}).then(res=>{
      if(res.total!=0){
        this.dataSource = res.rows
        this.dataSource.map((cur,index)=>{
          let arr = cur.platforms.split(',')
          this.dataSource[index].netCount = arr.length
          let arr1 = cur.receiveEmail.split(',')
          this.dataSource[index].emailCount = arr1.length
          let arr2 = cur.keywords.split('，')
          this.dataSource[index].keywordCount = arr2.length
        })
      }else{
        this.dataSource = []
      }
      this.total = res.total
      // if(res.total>=20){
      //   this.showBtn = false
      // }else{
      //   this.showBtn = true
      // }
      // this.pagination = {
      //   total: 10
      // }
    })
  },
},
mounted(){
  this.getData()
}
}
 
</script>

<style lang="scss" scoped>

.warninglogin {
  background: rgba(240, 242, 245, 1);
  display: flex;
  flex-direction: column;
    .hoverBottomWapper{
    width: 100%;
    .hoverBottom1{
      position: relative;
      width:100%;
      // text-align:center;
      //  padding:0px 0 10px 0;
      width:fit-content;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
           position: relative;
           padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  }
  /deep/.ant-table-thead>tr>th{
    font-weight: bold;
  }
  .dataContent{
    background: #fff;
    padding: 24px;
    min-height: 280px;
    width: 79%;
    margin: 0 auto;
  }
  /deep/.bgCrumb{
    padding: 48px 116px 65px 98px;
    margin-bottom: 60px;
    font-size: 24px;
    font-weight: bold;
    font-family: 'Microsoft Tai Le Bold', 'Microsoft Tai Le', sans-serif;
    background-color: #fff;
  }
  /deep/.ant-breadcrumb-link{
    font-size: 20px;
  }
  .row1{
    text-align: right;
    margin: 10px 0 20px 0;
    display: inline-block;
  }
  .ant-pagination{
    margin-top: 30px;
    text-align: right;
  }
 
  .form-class {
    display: flex;
    flex-direction: column;
  }
}
</style>